import React, { Component } from 'react'
import {
  APP_CONTEXT_PARTNERS_RECEIVE,
  fetchPartners,
  setAppContext,
  setShowProgressIndicator,
  updateContextSelection,
  setShowContext} from '../modules/appContext'
import Button from 'material-ui/Button'
import { bindActionCreators, compose } from 'redux'
import { CircularProgress } from 'material-ui/Progress'
import { connect } from 'react-redux'
import Dialog, {
    DialogActions,
    DialogContent,
    DialogTitle,
  } from 'material-ui/Dialog'
import { fetchClientList } from '../modules/client'
import { fetchInitialData } from '../modules/loading'
import { Field, reduxForm } from 'redux-form'
import { FormControl, FormHelperText } from 'material-ui/Form'
import Input, { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'
import Messages from '../constants/messages'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import { required } from '../utils/validationRules'
import Select from 'material-ui/Select'
import { SubmissionError } from 'redux-form'
import withStyles from 'material-ui/styles/withStyles'
import { hasMembership } from '../utils/helpers';
import { nordAdmins } from '../constants/memberships';

const PROP_TYPES = {
  fetchInitialData: PropTypes.func.isRequired,
  fetchPartners: PropTypes.func.isRequired,
  showAppContextDialog: PropTypes.bool.isRequired,
  showProgressIndicator: PropTypes.bool.isRequired
}

const styles = theme => ({
  buttonWrapper: {
    position: 'relative',
    margin: '0 10px 10px'
  },
  buttonProgress: {
    color: '#ffffff',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  dialogContent: {
    width: 500
  },
  formControl: {
    marginBottom: 10
  }
})

export class AppContextDialog extends Component {

  componentDidMount() {
    const { clientList, fetchClientList } = this.props
    if (!clientList || (clientList && clientList.length === 0)) {
      fetchClientList()
    }
  }

  handleFormSubmit = (values) => {
    const {
      changePage,
      fetchInitialData,
      fetchPartners,
      setAppContext,
      setShowContext,
      setShowProgressIndicator } = this.props

    setShowProgressIndicator(true)
    return setAppContext(values.appId).then(() => {
      setShowContext(false)

      if(!values.partnerIds) {
        fetchInitialData()
        changePage()
      } else {
        return fetchPartners(values.partnerIds).then((data) => {
          if(data.type === APP_CONTEXT_PARTNERS_RECEIVE) {
            if(data.payload.message === '') {
              fetchInitialData()
              changePage()
            } else {
              setShowContext(true)
              setShowProgressIndicator(false)
              // partner id(s) doesn't exist error
              throw new SubmissionError({
                partnerIds: data.payload.message
              })
            }
          } else {
            setShowContext(true)
            setShowProgressIndicator(false)
            throw new SubmissionError({
              partnerIds: 'Error from NAuth AuthZ API'
            })
          }
        })
      }
    })
    .catch(err => { throw err })
  }

  shouldPromptForPartnerIds() {
    const { userMemberships } = this.props
    return hasMembership(userMemberships, nordAdmins)
  }

  renderApps(clientList) {
    let markup = <MenuItem value="load">{Messages['uiComponents']['LOADING_MSG']}</MenuItem>
    if (clientList.length > 0) {
      markup = clientList.map((app, i) => {
        return <MenuItem data-test-id="appOptions" key={i} value={app.id}>{app.name}</MenuItem>
      })
    }
    return markup
  }

  renderPartnerIdsInput() {
    const { classes } = this.props
    return (
      <Field
      classes={classes}
      test="partnerIds"
      name="partnerIds"
      label={Messages['uiComponents']['APP_CONTEXT_INPUT_LABEL']}
      component={this.renderTextField}
      validate={[required]} />
    )
  }

  renderTextField(props) {
    const {
      helperText,
      input,
      label,
      meta: {
        touched,
        error
      },
      name,
      test,
      type
    } = props

    return (
      <div data-test-id="partnerIdsField" className="form-field">
        <FormControl fullWidth={true} error={touched && error}>
          <InputLabel htmlFor={name}>{label}</InputLabel>
          <Input
            data-test-id={test}
            autoFocus
            id={name}
            className="input-field"
            {...input}
            type={type} />
          <FormHelperText>{touched && error ? error : helperText}</FormHelperText>
        </FormControl>
      </div>
    )
  }

  renderAppSelect(props) {
    const {
      classes,
      clientList,
      helperText,
      input,
      meta: {
        touched,
        error
      },
      renderApps,
      updateContextSelection
    } = props

    return (
      <FormControl className={classes.formControl} fullWidth error={touched && error}>
        <InputLabel htmlFor="appId">{Messages['uiComponents']['APP_CONTEXT_SELECT_LABEL']}</InputLabel>
        <Select
          data-test-id="appSelector"
          {...input}
          onChange={(e) => {
            updateContextSelection(e.target.value)
          }}>
          { renderApps(clientList) }
        </Select>
        <FormHelperText>{touched && error ? error : helperText}</FormHelperText>
      </FormControl>
    )
  }

  render() {
    const {
      app,
      classes,
      clientList,
      handleSubmit,
      invalid,
      showAppContextDialog,
      showProgressIndicator,
      submitting,
      updateContextSelection } = this.props

    return (
      <div>
        <Dialog open={showAppContextDialog} ignoreBackdropClick={true}>
          <DialogTitle data-test-id="dialogTitle">{Messages['uiComponents']['APP_CONTEXT_TITLE']}</DialogTitle>
          <form onSubmit={ handleSubmit(this.handleFormSubmit) }>
            <DialogContent className={classes.dialogContent}>
              <Field
                app={app}
                classes={classes}
                name="appId"
                clientList={clientList}
                component={this.renderAppSelect}
                updateContextSelection={updateContextSelection}
                renderApps={this.renderApps}
                validate={[required]} />
              { this.shouldPromptForPartnerIds() ? this.renderPartnerIdsInput() : null }
            </DialogContent>
            <DialogActions>
              <div className={classes.buttonWrapper}>
                <Button
                  data-test-id="appContextContinue"
                  raised
                  type="submit"
                  color="primary"
                  disabled={showProgressIndicator || clientList.length === 0 || invalid || submitting}>
                  Continue
                </Button>
                {showProgressIndicator && <CircularProgress size={24} className={classes.buttonProgress} />}
              </div>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    )
  }
}

AppContextDialog.propTypes = PROP_TYPES

const mapStateToProps = state => ({
  app: state.appContext.appInfo,
  clientList: state.client.clientList,
  initialValues: state.appContext.initialValues,
  showAppContextDialog: state.appContext.showAppContextDialog,
  showProgressIndicator: state.appContext.showProgressIndicator,
  userMemberships: state.authProfile.userMemberships
})

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: () => push('/users'),
  fetchClientList,
  fetchInitialData,
  fetchPartners,
  setAppContext,
  setShowContext,
  setShowProgressIndicator,
  updateContextSelection
}, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: 'AppContextDialog',
    enableReinitialize: true,
  })
)(AppContextDialog)
